const INTERCOM_POLL_INTERVAL_MS = 500;
const INTERCOM_SHOW_DELAY_MS = 50;
const INTERCOM_MAX_ATTEMPTS = 20;

const showIntercom = () => {
  window.Intercom('hide');
  setTimeout(() => {
    window.Intercom('show');
  }, INTERCOM_SHOW_DELAY_MS);
};

/**
 * Opens the Intercom messenger. Polls until the SDK is ready if needed.
 * @param {{ email?: string }} [options]
 */
const openIntercom = ({ email } = {}) => {
  let attempts = 0;

  const tryOpen = () => {
    if (!window.Intercom) {
      attempts += 1;
      if (attempts < INTERCOM_MAX_ATTEMPTS) {
        setTimeout(tryOpen, INTERCOM_POLL_INTERVAL_MS);
      }
      return;
    }

    if (email) {
      window.Intercom('update', { email });
    }

    showIntercom();
  };

  tryOpen();
};

export default openIntercom;
